import { render, staticRenderFns } from "./ipReportSection.vue?vue&type=template&id=3bc6e8a2&scoped=true&"
import script from "./ipReportSection.vue?vue&type=script&lang=js&"
export * from "./ipReportSection.vue?vue&type=script&lang=js&"
import style0 from "./ipReportSection.vue?vue&type=style&index=0&id=3bc6e8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6e8a2",
  null
  
)

export default component.exports